<template>
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="34"
      height="34"
      rx="6"
      fill="#1F9AFF"
    />
    <path
      d="M25.8782 10.4191C25.6211 13.1277 24.5068 19.7106 23.9411 22.7448C23.7011 24.0306 23.2211
      24.4591 22.7754 24.5106C21.7811 24.5963 21.0268 23.8591 20.0668 23.2248C19.3082 22.7248
      18.7143 22.3202 18.126 21.9194C17.5444 21.5232 16.9683 21.1306 16.2439 20.6534C14.7756
      19.6894 15.3989 19.0974 16.2264 18.3115C16.3554 18.189 16.4893 18.0618 16.6211
      17.9277C16.6674 17.8814 16.8476 17.7139 17.1126 17.4683C18.3191 16.35 21.2822 13.6114
      21.3525 13.3163C21.3644 13.2617 21.3628 13.2051 21.3479 13.1514C21.333 13.0976 21.3051
      13.0483 21.2668 13.0077C21.1639 12.922 21.0268 12.9563 20.9068 12.9734C20.7525 13.0077
      18.3525 14.602 13.6725 17.7563C12.9868 18.2191 12.3697 18.4591 11.8211 18.442C11.2039
      18.4248 10.0382 18.0991 9.16394 17.8077C8.08394 17.4648 7.24394 17.2763 7.31251
      16.6763C7.3468 16.3677 7.77537 16.0591 8.58108 15.7334C13.5868 13.5563 16.9125
      12.1163 18.5754 11.4306C23.3411 9.44198 24.3182 9.09912 24.9697 9.09912C25.1068
      9.09912 25.4325 9.13341 25.6382 9.30484C25.8097 9.44198 25.8611 9.63055 25.8782
      9.76769C25.8611 9.87055 25.8954 10.1791 25.8782 10.4191Z"
      fill="#F7F8FD"
    />
  </svg>
</template>